import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ReportCellsComponent from './reportscells'


@Component(
    {
        name: 'reportoee',
        components: {
            oee: require("./reportscells.vue.html").default
        }
    })
export default class ReportOeeComponent extends Vue {
    charts: ReportCellsComponent[]=[];

    mounted() {
        this.addChart();
    }

    addChart() {
        this.charts.push(new ReportCellsComponent());
    }

}
